import { URLS } from "@core/shared/utils";
import { useIsLoggedIn } from "@framework/account/hooks";
import { userAtom } from "@framework/config/atoms";
import { platformFeaturesAtom } from "@framework/shared/atoms";
import { trans } from "@mongez/localization";
import {
  FileText,
  GraduationCap,
  Medal,
  Percent,
  Target,
  Trophy,
  UsersRound,
} from "lucide-react";

export function useNavigationLinks() {
  const isLoggedIn = useIsLoggedIn();
  const user = userAtom.useValue();
  const platformFeatures = platformFeaturesAtom.useValue();

  return [
    // { to: URLS.courses.list, label: trans("courses.title"), icon: BookOpen },
    {
      to: URLS.lessons.list,
      label: trans("grades.lessons"),
      icon: GraduationCap,
      isSpecial: false,
    },
    isLoggedIn &&
      platformFeatures.quizzes === true && {
        to: URLS.assessments.list,
        label: trans("assessments.exams"),
        icon: FileText,
        isSpecial: true,
      },
    isLoggedIn &&
      user.isStudent === true &&
      platformFeatures.trainingGround === true && {
        to: URLS.trainingGround,
        label: trans("trainingGround.navigation"),
        icon: Target,
        isSpecial: true,
      },
    isLoggedIn &&
      user.isStudent === true &&
      platformFeatures.league === true && {
        to: URLS.league,
        label: trans("league.navigation"),
        icon: Medal,
        isSpecial: true,
      },
    isLoggedIn &&
      platformFeatures.communityGroups === true && {
        to: URLS.communityGroups.list,
        label: trans("communityGroups.navigation"),
        icon: UsersRound,
        isSpecial: false,
      },
    {
      to: URLS.leaderboard.topAssessments,
      label: trans("leaderboard.title"),
      icon: Trophy,
      isSpecial: true, // Mark leaderboard as special for enhanced styling
    },
    // Challenges link hidden temporarily — re-enable here when the
    // feature ships publicly. Keep the import + URL constant in place
    // so the route + page are still reachable directly.
    // {
    //   to: URLS.challenges.list,
    //   label: trans("challenge.navLink"),
    //   icon: Swords,
    //   isSpecial: true,
    // },
    {
      to: URLS.offers.list,
      label: trans("offers.title"),
      icon: Percent,
      isSpecial: false,
    },
    // { to: URLS.grades.list, label: trans("grades.title"), icon: Award },
  ].filter(Boolean) as {
    to: string;
    label: string;
    icon: React.ElementType;
    isSpecial?: boolean;
  }[];
}
